import TZH from "../images/tiger-zinda-hai.jpg";
import AIW from "../images/Avengers-infity-war.jpg";
import BB from "../images/bajrangi-bhaijaan.jpg";
import AEG from "../images/avengers-endgame.jpg";
import KBKJ from "../images/kisikabhai-kisikijaan.jpg";
import T3 from "../images/tiger3.jpg";
import D2 from "../images/Drishyam-2.jpeg";
import BPWF from "../images/Black-Panther-Wakanda-Forever.webp";
import PB from "../images/Phone-Bhoot.jpg";
import RS from "../images/ram-setu.jpg";

const MovieData = [
  {
    id: 1,
    name: "Drishyam 2",
    language: "Hindi, Tamil, Telugu",
    releaseDate: "18 Nov, 2022",
    Resolution: "2D",
    certifcation: "UA",
    runningHours: "2 hrs 2 min",
    genres: "Drama, Mystery, Thriller",
    image: D2,
    rating: { rate: 8.7, count: 99.7 },
    about: `A gripping tale of an investigation and a family which is threatened by it. Will Vijay Salgaonkar be able to protect his family this time?`,
    link: "https://www.youtube.com/embed/cxA2y9Tgl7o",
  },
  {
    id: 2,
    name: "Black Panther: Wakanda Forever",
    language: "English, Hindi, Tamil, Telugu",
    releaseDate: "11 Nov, 2022",
    Resolution: "2D, 3D",
    certifcation: "UA",
    runningHours: "2 hrs 44 min",
    genres: "Action, Adventure, Drama",
    image: BPWF,
    rating: { rate: 8.8, count: 33.4 },
    about:
      "Queen Ramonda, Shuri, M'Baku, Okoye and the Dora Milaje fight to protect the kingdom of Wakanda from intervening world powers in the wake of King T'Challa's death. As the Wakandans strive to embrace their next chapter, the heroes must band together with the help of War Dog Nakia and Everett Ross and forge a new path for their nation.",
    link: "https://www.youtube.com/embed/_Z3QKkl1WyM",
  },
  {
    id: 3,
    name: "Phone Bhoot",
    language: "Hindi",
    releaseDate: "04 Nov, 2022",
    Resolution: "2D",
    certifcation: "UA",
    runningHours: "2 hrs 17 min",
    genres: "Comedy, Horror",
    image: PB,
    rating: { rate: 6.6, count: 7.9 },
    about: `Major and Gullu two friends who are obsessed with horror since childhood want to make their careers on something related to it but whatever business they have started always failed.During one Halloween party they come across an unknown beautiful women and cant get over her she traces them to their house and discloses that she is a ghost and they can interact with her normally as they have been god gifted with some powers.The women tells that together they can start a business where they can free spirits who are waiting for salvation but both decline the plan,next day when both their fathers come to visit them Major and Gullu are told that further they wont be supported by them and till date they have to reimburse them the amount of 5 Crore spent on them.Major and Gullu decide to steal the idea of the women and start a Phone Bhoot where people can connect with them to free spirits but they become a joke on the internet until one day they receive a call from Panchgani to free a spirit.Upon reaching the place they find that spirit is over powering them until the unknown lady comes to their aid she tells them she is Ragini and the assignment was given to them by her after they stole her idea.The trio then decide to work together to free spirits who need salvation but an evil Tantrik Aatmaram comes on their way who captures spirits by promising them salvation but uses them for bad causes.`,
    link: "https://www.youtube.com/embed/5fTVslrPsL0",
  },
  {
    id: 4,
    name: "Thank God",
    language: "Hindi",
    releaseDate: "25 Oct, 2022",
    Resolution: "2D",
    certifcation: "UA",
    runningHours: "2 hrs 1 min",
    genres: "Comedy, Drama, Fantasy",
    image: TZH,
    rating: { rate: 7.2, count: 18.1 },
    about: `An egoistic real estate broker in huge debts, meets with an accident. As he gains consciousness, he realizes that he is in heaven. God appears in front of him and informs him that he will have to play a "GAME OF LIFE". If he manages to win, he will be sent back to earth and if he loses, he will be sent to hell.`,
    link: "https://www.youtube.com/embed/x-sgnhYJGOA",
  },
  {
    id: 5,
    name: "Ram Setu",
    language: "Hindi, Tamil, Telugu",
    releaseDate: "25 Oct, 2022",
    Resolution: "2D",
    certifcation: "UA",
    runningHours: "2 hrs 22 min",
    genres: "Action, Adventure, Thriller",
    image: RS,
    rating: { rate: 8.1, count: 39.6 },
    about: `Dr Aryan Kulshreshta is felicitated in Afghanistan by the archaeological department for discovering a treasure on archaeological site and saving it from Taliban.Upon his return he is promoted as the director in his organization and gets the chance to make a report on going issue in the country about Ram Setu being natural or man made as government plans to demolish it due to industrial development.Aryan's being an atheist drafts his reports which creates and issue over the country about Ramayan and existence of Ram for which he faces suspension and his family has to face the brunt.His wife asks him to stay away from the controversy for family sake but Aryan decides to clear his name and gets chance to work with Pushpak Shipping whose owner Indrakant is behind the urban development and wants evidence on Ram Setu not being built by Ram.Aryan arrives at the site of Ram Setu and gets to work with project manager Bali and his team one being Dr Sandra Rebello but underwater he has to work carefully and not cross Srilankan borders due to ongoing civil war.Aryan discovers a floating stone underwater which proves that Ram Setu existed before BC and was possibly built by Ram but Indrakant asks the to get more evidence to prove the same.Aryan,Sandra and Dr Gabrielle go on a night mission underwater to unfold the mystery but find that they are made scapegoat in a plan and left top die under water in stormy weather by Bali and Indrakant.Dr Gabrille acts smart by taking the floating stone along with them as she suspected Bali, in mid sea they are saved by a Srilankan fisherman AP.Bali finds that the stone is missing and decides to chase them but AP helps them cross the borders and the stone goes missing in the chase while Gabrielle is shot by Bali. Aryan now along with Sandra and AP decides to prove the existence of Ram and Ram Setu by doing his research across borders in Srilanka which has existence of Raavana and itself will be a big evidence that Ram Setu was not natural but built by Ram.`,
    link: "https://www.youtube.com/embed/VgGgYOzNWno",
  },
  {
    id: 6,
    name: "Tiger Zinda Hai",
    language: "Hindi, Tamil, Telugu",
    releaseDate: "22 Dec, 2017",
    Resolution: "2D",
    certifcation: "U/A",
    runningHours: "2 hrs 51 min",
    genres: "Action, Thriller, Comedy, Drama",
    image: TZH,
    rating: { rate: 8.1, count: 39.2 },
    about:
      "Inspired by real events, Tiger Zinda Hai is a sequel to the blockbuster Ek Tha Tiger, and an espionage action thriller that follows a daring rescue mission in Iraq. When a group of Indian and Pakistani nurses are held hostage in Iraq by the militant Abu Usman, Indian intelligence (RAW) tracks down the reclusive agent Tiger 8 years after he fled with former Pakistani intelligence (ISI) agent Zoya. Joining forces in the name of humanity, Tiger and Zoya lead a team of RAW and ISI agents to covertly enter the hospital where the nurses are trapped, and get the nurses to safety before an American airstrike blows up the hospital. Tiger Zinda Hai is an all out entertainer with gritty action, music and thrill.",
    link: "https://www.youtube.com/embed/ePO5M5DE01I",
  },

  {
    id: 7,
    name: "Avengers: Infinity Wars",
    language: "English, Hindi",
    releaseDate: "27 Apr, 2018",
    Resolution: "3D",
    certifcation: "U/A",
    runningHours: "2 hrs 29 min",
    genres: "Action, Sci-fi",
    image: AIW,
    rating: { rate: 8.4, count: 399.2 },
    about:
      "As the Avengers and their allies have continued to protect the world from threats too large for any one hero to handle, a new danger has emerged from the cosmic shadows: Thanos. A despot of intergalactic infamy, his goal is to collect all six Infinity Stones, artifacts of unimaginable power, and use them to inflict his twisted will on all of reality. Everything the Avengers have fought for has led up to this moment, the fate of Earth and existence has never been more uncertain.",
    link: "https://www.youtube.com/embed/6ZfuNTqbHE8",
  },
  {
    id: 8,
    name: "Bajrangi Bhaijaan",
    language: "Hindi",
    releaseDate: "17 Jul, 2015",
    Resolution: "2D",
    certifcation: "U/A",
    runningHours: "2 hrs 39 min",
    genres: "Action, Drama, Comedy",
    image: BB,
    rating: { rate: 8.1, count: 89.2 },
    about: `A little mute girl from a Pakistani village gets lost on her return back from a trip to India. In Kurukshetra, she meets Pawan - an ardent devotee of Lord Hanuman - who is in the midst of a challenge posed by his lover's father. In trying to discover the girl's parents, he develops an unshakable bond with her. He tries to get into Pakistan through a path righteous to his conscience and later, accompanied with a smart Pakistani news reporter - a story that captures the imagination of the public in both countries.`,
    link: "https://www.youtube.com/embed/4nwAra0mz_Q",
  },
  {
    id: 9,
    name: "Avengers: Endgame",
    language: "English, Hindi",
    releaseDate: "26 Apr, 2019",
    Resolution: "3D",
    certifcation: "U/A",
    runningHours: "3 hrs 2 min",
    genres: "Action, Sci-fi",
    image: AEG,
    rating: { rate: 8.1, count: 399.2 },
    about: `After the devastating events of Avengers: Infinity War (2018), the universe is in ruins due to the efforts of the Mad Titan, Thanos. With the help of remaining allies, the Avengers must assemble once more in order to undo Thanos's actions and undo the chaos to the universe, no matter what consequences may be in store, and no matter who they face...`,
    link: "https://www.youtube.com/embed/TcMBFSGVi1c",
  },
  {
    id: 10,
    name: "Kisi ka Bhai Kisi Ki Jaan",
    language: "Hindi",
    releaseDate: "21 Apr, 2023",
    Resolution: "3D",
    certifcation: "U/A",
    runningHours: "2 hrs 50 min",
    genres: "Action, Drama, Thriller",
    image: KBKJ,
    rating: { rate: 8.1, count: 399.2 },
    about: `The story of a elder brother who is ageing but still a bachelor. His action packed life finds romance where he also gets involved in so many action sequences.`,
    link: "https://www.youtube.com/embed/K36D16cvum4",
  },
  {
    id: 11,
    name: "Tiger 3",
    language: "Hindi",
    releaseDate: "10 Nov, 2023",
    Resolution: "3D",
    certifcation: "U/A",
    runningHours: "2 hrs 50 min",
    genres: "Mystery, Adventure",
    image: T3,
    rating: { rate: 8.1, count: 399.2 },
    about: `Third Installment of most successful movie franchise of Hindi Cinema "Tiger"`,
    link: "https://www.youtube.com/embed/Jw3UyeMmOdw",
  },
];

export default MovieData;
